import { ForYouProp } from '../models/sectionForYou'

import imageCard1 from '../assets/posto-image.png'
import imageCard2 from '../assets/shell-box-image.png'
import imageCard3 from '../assets/shell-select.png'

export const getForYou = async (): Promise<ForYouProp> => {
  return Promise.resolve([
    {
        title: "Para Você",
        description: "Soluções da Shell pensadas para facilitar sua rotina como motorista, com mais conveniência, praticidade e acesso rápido a serviços no dia a dia.",
        solutions: [
            {
                id: '1',
                model: '',
                title: 'Postos Shell',
                text: '<strong>Os postos Shell reúnem tecnologia e serviços para ajudar você</strong> a encontrar a parada ideal e seguir seu trajeto com mais conforto e segurança. Baixe o app Shell Box e encontre um posto Shell.',
                image: imageCard1,
                actions: [
                    {
                        title: 'Encontre um posto Shell',
                        url: 'https://shellbox.onelink.me/RT9I/apqg8dir'
                    }
                ]
            },{
                id: '2',
                model: 'purple',
                title: 'Shell Box',
                text: '<strong>Com o aplicativo Shell Box, você paga abastecimentos direto pelo celular,</strong> encontra postos Shell próximos e aproveita benefícios exclusivos no seu dia a dia.',
                image: imageCard2,
                actions: [
                    {
                        title: 'Baixe o app Shell Box',
                        url: 'https://shellbox.onelink.me/RT9I/37o3qrcr'
                    }
                ]
            },{
                id: '3',
                model: '',
                title: 'Shell Box Clube',
                text: '<strong>Faça parte do programa de fidelidade do app.</strong> Quanto mais Shell Box na sua rotina, mais benefícios você vai ter para escolher.',
                image: imageCard3,
                actions: [
                    {
                        title: 'Saiba mais',
                        url: 'https://www.shell.com.br/motoristas/app-shell-box/programa-de-fidelidade/shell-box-clube.html?utm_source=promoshell&utm_medium=saiba-mais-shell-box-clube&utm_id=home'
                    }
                ]
            }
        ]
    }
  ])
}